import PersonGift3d from "@/assets/images/3d-illus/person-gift.png";
import LightBlueBackground from "@/assets/images/background-theme/light-blue-background.png";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { useRoute } from "@/components/shared/router";
import { Typography } from "@/components/shared/typography";
import { Button, Card, CardContent, Image, View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { ImageBackground } from "@/components/ui/image-background";
import { sendAnalyticData } from "@/lib/monitoring/analytics";
import { useAuthState } from "@/store/auth";

import { useWindowDimensions } from "../../../../components/hooks/use-window-dimension";
import { HERO_BUTTON_CLASS, SectionRedeem } from "./section-redeem";

export const GiftCardHero = () => {
  const { top } = useSafeAreaInsets();
  const { pull, push } = useRoute();
  const { isMobile } = useWindowDimensions();
  const accountType = useAuthState((state) => state.data.userInfo.accountType);

  const handleClickGiftCard = () => {
    sendAnalyticData({
      name: "initiate_gift_card",
      values: {
        account_type: accountType,
      },
    });
    push("/profile/gift-card/new");
  };

  return (
    <ImageBackground
      src={LightBlueBackground} // fulfilling figma expectation
      className="relative rounded-b-lg"
      gap={0}
      position={isMobile ? "top" : "bottom"}
      style={{
        paddingTop: top,
      }}
    >
      <View className="native:flex web:hidden flex-row items-center gap-4 py-3">
        <IconButton
          variant="ghost"
          color="foreground"
          iconName="arrowLeft"
          rounded="full"
          className="p-0 md:hidden"
          onClick={() => pull()}
        />
        <Typography variant="label-md" color="foreground-default">
          Gift Card
        </Typography>
      </View>
      <View className="flex flex-row items-start gap-3 pt-4">
        <View className="flex flex-1 flex-col gap-1 pt-4">
          <Typography variant="h3" color="brand-primary">
            Give a Gift, Anytime
          </Typography>
          <Typography variant="body-sm" color="brand-primary">
            A simple way to treat someone you care about.
          </Typography>
        </View>
        <View className="h-[133px] w-[133px]">
          <Image src={PersonGift3d} className="h-full w-full" />
        </View>
      </View>
      <Card radius="xl" shadow="sm" className="-mt-2 p-0">
        <CardContent className="web:flex-wrap flex flex-row items-center gap-2 p-3">
          <SectionRedeem />
          <Button
            size={"lg"}
            onClick={handleClickGiftCard}
            variant={"primary"}
            color={"CTA"}
            fullWidth="full"
            className={HERO_BUTTON_CLASS}
          >
            Send Gift Card
          </Button>
        </CardContent>
      </Card>
    </ImageBackground>
  );
};
